/**
 * Pure helper functions matching a selected country (from COUNTRY_CATALOG) to
 * dealers by comparing country names against the partner-locations labels
 * already present on each dealer (see countryCatalog.ts for why).
 */

import { COUNTRY_CATALOG } from './countryCatalog';
import type { Distributor } from './types';

function normalize( label: string ): string {
	return label.trim().toLowerCase().normalize( 'NFD' ).replace( /[̀-ͯ]/g, '' ); // strip diacritics (Ö -> O, etc.)
}

const ALIAS_TO_CODE = new Map< string, string >();
COUNTRY_CATALOG.forEach( ( country ) => {
	[ country.name, ...country.matchAliases ].forEach( ( alias ) => {
		ALIAS_TO_CODE.set( normalize( alias ), country.code );
	} );
} );

export function countryCodeForLabel( label: string ): string | undefined {
	return ALIAS_TO_CODE.get( normalize( label ) );
}

export function getDealersForCountryName(
	dealers: Distributor[],
	countryName: string
): Distributor[] {
	const code = countryCodeForLabel( countryName );
	if ( ! code ) {
		return [];
	}
	return dealers.filter( ( d ) =>
		( d.locations ?? [] ).some(
			( loc ) => countryCodeForLabel( loc.label ) === code
		)
	);
}

export function isDistribuidorValidForCountry(
	dealers: Distributor[],
	countryName: string,
	distribuidorName: string
): boolean {
	if ( ! distribuidorName ) {
		return true; // empty is handled by required-field validation elsewhere
	}
	return getDealersForCountryName( dealers, countryName ).some(
		( d ) => d.name === distribuidorName
	);
}
